import * as THREE from 'three';

// import axios from 'axios'

// function formatTime(date) {
//     return date.getFullYear()
//         + "/" + (date.getMonth() + 1).toString().padStart(2, '0')
//         + "/" + date.getDate().toString().padStart(2, '0')
//         + " " + date.getHours().toString().padStart(2, '0')
//         + ":" + date.getMinutes().toString().padStart(2, '0');
//     // + ":" + date.getSeconds().toString().padStart(2, '0');
// }

function getExportSize2(group) {
    let box3 = new THREE.Box3();
    let volume = 0;
    if (group.isGroup) {
        for (let i = 0, len = group.children.length; i < len; i++) {
            let obj = group.children[i];
            let objSize = getExportSize2(obj);
            volume += objSize.volume;
            box3.expandByPoint(objSize.box3.min);
            box3.expandByPoint(objSize.box3.max);
        }
    } else if (group instanceof Array) {
        for (let i = 0, len = group.length; i < len; i++) {
            let obj = group[i];
            let objSize = getExportSize2(obj);
            volume += objSize.volume;
            box3.expandByPoint(objSize.box3.min);
            box3.expandByPoint(objSize.box3.max);
        }
    } else if (group.isMesh) {
        group.updateWorldMatrix(false, false);
        volume += volumeOfGeometry(group.geometry, group.matrixWorld);
        box3.expandByObject(group);
    }

    return {
        volume: volume,
        box3: box3
    }
}

export function volumeOfGeometry(geometry, matrixWorld) {
    var volume = 0;
    if (geometry.index) {
        var positions = geometry.attributes.position;
        var indices = geometry.index;
        for (var i = 0; i < indices.count; i += 3) {
            var a = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i]);
            var b = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i + 1]);
            var c = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i + 2]);
            a.applyMatrix4(matrixWorld);
            b.applyMatrix4(matrixWorld);
            c.applyMatrix4(matrixWorld);

            volume += __signedVolumeOfTriangle(a, b, c);
        }
    } else {
        var positions = geometry.attributes.position;
        for (var i = 0; i < positions.count; i += 3) {
            var a = new THREE.Vector3().fromBufferAttribute(positions, i);
            var b = new THREE.Vector3().fromBufferAttribute(positions, i + 1);
            var c = new THREE.Vector3().fromBufferAttribute(positions, i + 2);
            a.applyMatrix4(matrixWorld);
            b.applyMatrix4(matrixWorld);
            c.applyMatrix4(matrixWorld);

            volume += __signedVolumeOfTriangle(a, b, c);
        }
    }
    return Math.abs(volume);
}


function __signedVolumeOfTriangle(p1, p2, p3) {
    var v321 = p3.x * p2.y * p1.z;
    var v231 = p2.x * p3.y * p1.z;
    var v312 = p3.x * p1.y * p2.z;
    var v132 = p1.x * p3.y * p2.z;
    var v213 = p2.x * p1.y * p3.z;
    var v123 = p1.x * p2.y * p3.z;
    var volume = (1.0 / 6.0) * (-v321 + v231 + v312 - v132 - v213 + v123);
    if (isNaN(volume)) {
        console.error("isNaN", p1, p2, p3);
    }
    return volume;
}


export default {
    data() {
        return {
            count: 1, // 打印份数
            price: 0, // 模型单价
            total: 0, // 总价
            length: 0, // 模型深度
            width: 0, // 模型宽度
            height: 0, // 模型高度
            volume: 0, // 模型体积
            image: "", // 模型截图：base64 url
            oldPrice: 0,//浮雕的旧价格

            deliveryDaysList: [],
            printMaterials: [],
            printColors: [],
            printMaterialIndex: -1,
            printColorIndex: -1,
            showPrint: false,
            showLowPrice: false,
            lowPrice: "",
            showlow: false,
            showStyle: false,
            showlowpriceHeight: false,
            deliveryDiscount: 0,
            deliveryDays: 0,
            addCartRuning: false,
            loading: false,
        };
    },
    watch: {
        deliveryDays() {
            this.showLowPrice = false;
            //console.log("选中下拉的天数", this.deliveryDays);
            if (this.volume > 0) {
                this.getPrice();
            }
        },
        count: function () {
            if (this.count == 0 || this.count == "") {
                this.getPrice();
                this.$vux.toast.show({
                    text: '数量不能为空！',
                    type: "warn",
                    time: 2000,
                    position: "middle",
                });
            } else {
                this.getPrice();
            }
        },
    },
    mounted() {
        const scope = this;
        scope.loadMaterials();
    },
    methods: {
        init3d(contentDOM, camera, renderer, resize) {
            // // 材质加载一次即可
            // this.loadMaterials();
            const scope = this;
            let winHeight = 0;
            scope.loading = true;

            // 根据手机旋转的角度来判断：用resize事件代替旋转事件
            window.addEventListener("resize", function (e) { //事件监听
                let width = document.documentElement.clientWidth;
                let height = document.documentElement.clientHeight;

                height = height + 55;
                contentDOM.style.height = height + "px";

                // height += 55 - 45; // 底部厚度
                contentDOM.style.width = width + 'px';
                scope.landscape = width > height + 100; // 是否横屏展示
                // //console.log('w, h 2', width, height, scope.landscape);
                contentDOM.style.top = '0px';
                contentDOM.style.left = '0px';
                contentDOM.style.paddingTop = "0px";
                contentDOM.style.right = '0px';
                contentDOM.style.bottom = '0px';

                //先判断是否在竖屏，竖屏状态下输入法强制设置宽高
                if (!scope.landscape) {
                    winHeight = Math.max(winHeight, window.innerHeight);
                    winHeight = Math.max(winHeight, window.innerWidth);

                    contentDOM.style.height = (winHeight + 55) + "px";
                }
                scope.$nextTick(function () { resize(e) });
            }, false);

            this.$nextTick(() => {
                // 这个函数不知为何被执行了两次
                window.dispatchEvent(new Event('resize')); // 主动触发resize事件
            });
        },

        //加入购物车
        addCart() {
            const scope = this;
            scope.addCartIndex = 0;
            scope.showLoading = true;
            scope.showPrint = false;

            if (scope.count == "" || scope.count == 0) {
                scope.count = "1";
                scope.getPrice();
                this.$vux.toast.show({
                    text: '数量不能为空！',
                    type: "warn",
                    time: 2000,
                    position: "middle",
                });
                scope.showPrint = true;
                scope.showLoading = false;
            }

            // 错误处理
            if (!scope.validOrder) {
                this.$vux.toast.show({
                    text: scope.errMsg,
                    type: "warn",
                    time: 2000,
                    position: "middle",
                });
                return;
            }

            setTimeout(function () {
                // addCartRuning保护，避免重复添加
                if (scope.addCartRuning) return;
                scope.addCartRuning = true;
                // await，改异步为同步，避免过早解除重入限制
                scope.cartOrBuy("toCart").then(function () {
                    scope.addCartRuning = false;
                    scope.showLoading = false;
                });
            }, 50);
        },

        //立即下单
        orderImmediately() {
            const scope = this;
            scope.orderIndex = 0;
            scope.showLoading = true;
            scope.showPrint = false;

            if (scope.count == "" || scope.count == 0) {
                scope.count = "1";
                scope.getPrice();
                this.$vux.toast.show({
                    text: '数量不能为空！',
                    type: "warn",
                    time: 2000,
                    position: "middle",
                });
                scope.showPrint = true;
                scope.showLoading = false;
            }
            // 错误处理
            if (!scope.validOrder) {
                this.$vux.toast.show({
                    text: scope.errMsg,
                    type: "warn",
                    time: 2000,
                    position: "middle",
                });
                return;
            }

            setTimeout(function () {
                // addCartRuning保护，避免重复添加
                if (scope.addCartRuning) return;
                scope.addCartRuning = true;
                // await，改异步为同步，避免过早解除重入限制
                scope.cartOrBuy("toBuy").then(function () {
                    scope.addCartRuning = false;
                    scope.showLoading = false;
                });
            }, 50);
        },

        makeStlBlob() {
            console.error("必须实现makeStlBlob方法");
        },

        getUploadUrl() {
            return "/SmallSoftware/uploadFile";
        },

        addOtherData(formData) { },

        cartOrBuy(type) {
            if (!this.$common.getCookie('_token')) {
                this.$router.push({
                    path: '/login',
                    query: {
                        fullPath: this.$route.fullPath
                    }
                });
                return Promise.resolve();
            }

            if (!this.validOrder) {
                this.$vux.toast.show({
                    text: this.errMsg,
                    type: "warn",
                    time: 2000,
                    position: "middle",
                });
                return Promise.resolve();
            }

            let blob = this.makeStlBlob();

            // blob文件上传本地
            let formData = new FormData();
            formData.append('myfile', blob);
            // formData.append('myfile', null);
            this.addOtherData(formData);
            let scope = this;
            scope.loading = true;

            return this.$request.post(scope.getUploadUrl(), formData).then(res => {
                //console.log('makemodel', res);
                // 错误处理
                if (res.code !== 0) {
                    scope.loading = false;
                    this.$vux.toast.show({
                        text: "操作失败：" + res.msg + "," + (res.obj || ""),
                        type: "warn",
                        time: 2000,
                        position: "middle",
                    });
                    return;
                }
                // 上传成功，插入一条doodle记录
                let ossFilePath = res.obj;

                let postData = {
                    length: scope.length,
                    width: scope.width,
                    height: scope.height,
                    volume: Math.ceil(scope.volume),
                    weight: scope.weight,
                    deliveryDays: scope.deliveryDays,
                    deliveryDiscount: scope.deliveryDiscount, //交期折扣
                    unit: 'mm',
                    manufactureId: scope.selectedMaterial.manufactureId,
                    manufactureName: scope.selectedMaterial.manufactureName,
                    materialId: scope.selectedMaterial.id,
                    materialName: scope.selectedMaterial.materialName,
                    quantity: scope.count,
                    fileName: scope.quotationName, // + formatTime(new Date()),
                    filePath: ossFilePath,
                    ossFileStl: ossFilePath,
                    image: scope.image,
                    listSurface: [],
                    quotationType: '',
                    colorId: scope.selectedColor.id,
                    colorName: scope.selectedColor.colorName,
                    // 产品类型
                    productType: scope.productType,
                };
                //console.log("productType", scope.quotationName);

                return scope.$request.post("/SmallSoftware/" + type, postData).then(res => {

                    if (res.code !== 0) {
                        scope.validOrder = false;
                        scope.errMsg = res.msg;
                        scope.$vux.toast.show({
                            text: res.msg,
                            type: "warn",
                            time: 2000,
                            position: "middle",
                        });
                        return;
                    }

                    if (type === "toBuy") {
                        // 跳转到立即下单页面   
                        scope.$router.push({
                            path: '/submitOrder',
                            query: {
                                cartType: 'cartdirect',
                            },
                        });
                    } else if (type === "toCart") {
                        //跳转到加入购物车页面
                        scope.$router.push({
                            path: '/shoppingCart'
                        });
                    } else {
                        scope.showPrint = false;
                        scope.$vux.toast.text('✔ 添加购物车成功')
                    }
                })
            });
        },

        // 最低价提示
        LowPrice() {
            this.showLowPrice = !this.showLowPrice;
        },

        //单价最低规则
        lowRole() {
            this.showLowPrice = false;
            this.$router.push({
                path: '/printNotice',
                query: {
                    title: 'minPrice',
                    type: '单件最低价'
                }
            });
        },

        //加减按钮数量
        reduce() {
            if (this.count <= 1) {
                this.count = 1;
                //console.log("reduce", this.count);
            }
            else {
                this.count--;
            }
            this.getPrice();
        },

        add() {
            this.count++;
            this.getPrice();
            //console.log("add", this.count);
        },

        //在线打印颜色的下拉选中
        printColorChange(e) {
            this.showLowPrice = false;
            this.printColorIndex = e.target.selectedIndex;
            this.getPrice();
        },

        //选中下拉的printMaterial
        printMaterialChange(e) {
            this.showLowPrice = false;
            this.printMaterialIndex = e.target.selectedIndex;
            this.printColorIndex = 0;
            // console.log('printMaterialIndex', this.printMaterialIndex);

            // 更新配送天数
            this.getDelivery(this.selectedMaterial.id);
        },

        //选中下拉的天数
        printTodayChange(e) {
            this.showLowPrice = false;
            this.deliveryDays = e.target.value;
            //console.log("选中下拉的天数", this.deliveryDays);
            if (this.volume > 0) {
                this.getPrice();
            }
        },

        //获取天数
        getDelivery(materialId) {
            let scope = this;
            this.$request.post('/delivery/listDelivery', { materialId })
                .then(function (data) {
                    //console.log("data", data);
                    scope.deliveryDaysList = data.obj;
                    // 可在此处判断是否是金属，如果是，则默认选择30天。
                    // 用id判断金属
                    if (materialId === '409fbdd9-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409fbcef-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409fbcef-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409fb9f4-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409f85a9-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409f8c14-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409f8cad-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409f8aca-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409f823c-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409fbc0a-c3a9-11e9-af9b-00163e0e2a52'
                        || materialId === '409f865e-c3a9-11e9-af9b-00163e0e2a52') {
                        // 最后一个天数
                        scope.deliveryDays = scope.deliveryDaysList[scope.deliveryDaysList.length - 1].days;
                    }
                    else {
                        scope.deliveryDays = scope.deliveryDaysList[scope.deliveryDaysList.length - 1].days;
                        //console.log("scope.deliveryDays", scope.deliveryDays);
                        // return;
                    }
                    // 更新价格
                    if (scope.volume > 0) {
                        scope.getPrice();
                    }
                });
        },

        getPriceLocal() {
            let material = this.printMaterials[this.printMaterialIndex];
            //console.log('getPriceLocal', material, this.volume);
            let weight = Math.ceil(this.volume) * material.density / 1000;
            weight = Math.round(weight * 10) / 10;
            let price = weight * material.price;
            price = Math.round(price * 0.9 * 10) / 10;
            this.validOrder = true;
            this.price = price;
            this.total = price;
        },

        // 抽离出来的加减数量方法
        getPrice() {
            // if (!this.showPrint) return;

            let _this = this;

            return this.$request.post('/SmallSoftware/create', {
                length: _this.length,
                width: _this.width,
                height: _this.height,
                volume: Math.ceil(_this.volume),
                unit: 'mm',
                minimumPrice: '',
                minimumPriceSign: _this.lowPrice,
                deliveryDays: _this.deliveryDays,
                deliveryDiscount: _this.deliveryDiscount,
                materialId: _this.printMaterials[_this.printMaterialIndex].id,
                materialName: _this.printMaterials[_this.printMaterialIndex].materialName,
                quantity: _this.count,
                listSurface: [],
                colorId: _this.printMaterials[_this.printMaterialIndex].listColor[_this.printColorIndex].id,
                colorName: _this.printMaterials[_this.printMaterialIndex].listColor[_this.printColorIndex].colorName,
                ossFileStl: '',
                image: _this.image,
                firstUpload: '',
                quotationName: _this.quotationName,
                // 产品类型
                productType: _this.productType,

            }).then(function (data) {
                //console.log("data is", data);
                // 错误处理
                // if (data.code !== 0) {
                //     _this.validOrder = false;
                //     _this.errMsg = data.msg;
                //     _this.$vux.toast.show({
                //         text: data.msg,
                //         type: "warn",
                //         time: 2000,
                //         position: "middle",
                //     });
                //     return;
                // }
                _this.validOrder = true;
                _this.price = data.obj.price;
                _this.total = data.obj.total;
                _this.deliveryDiscount = data.obj.deliveryDiscount;
                _this.deliveryDays = data.obj.deliveryDays;
                _this.oldPrice = (data.obj.weight * 0.8).toFixed(1);

                //console.log("oldPrice", _this.oldPrice);

                //console.log("天数", _this.deliveryDays, _this.price, _this.total);
                //console.log("deliveryDiscount1", _this.deliveryDiscount);

                // 判断最低价显示和隐藏,1就是显示，0就不显示,
                //我的目标是最低价<5的时候就显示弹窗，所以应该是搞反的
                if (_this.minimumPriceSign == 0 && _this.total <= 5 || _this.total == 5) {
                    _this.showlow = true;
                    _this.showStyle = false;
                    _this.showlowpriceHeight = true;
                    //console.log("display:none 0就不显示", _this.total);
                } else if (_this.minimumPriceSign == 1 && _this.total > 5 || _this.total > 5 || _this.minimumPriceSign == "") {
                    _this.showlow = false;
                    _this.showStyle = true;
                    _this.showlowpriceHeight = false;
                    //console.log("1就是显示");
                }
            })
        },

        getDefaultMaterialIndex() {
            if (this.productType === "花瓶" || this.productType === "招牌文字" || this.productType === "收纳盒"
                || this.productType === "手机壳定制" || this.productType === "3D字" || this.productType === "3d人头像" || this.productType === "浮雕摆件"
                || this.productType === "装饰画" || this.productType === "贴纸雕刻笔筒" || this.productType === "定制首饰挂件" || this.productType === "泰森纹笔筒"
                || this.productType === "随机Voronoi摆件" || this.productType === "多面体摆件" || this.productType === "随机voro立方体" || this.productType === "斜式笔筒"
                || this.productType === "3D竹蜻蜓" || this.productType === "二维码") {
                return 0;
            } else {
                return 0;
            }
        },

        //加载材质
        loadMaterials() {
            const scope = this;

            this.$request.post('/SmallSoftware/listMaterials', { "materialType": "定制" }).then(function (res) {
                // 装配材质列表，按照单价排序：密度 * 单价
                // scope.printMaterials = res.obj.sort((a, b) => a.density * a.price - b.density * b.price);

                // 过滤掉材料里面的某个材质
                if (scope.productType === "浮雕相框") {
                    scope.printMaterials = res.obj;
                }else {
                    scope.printMaterials = res.obj.filter(item => item.materialName.indexOf("全彩光敏树脂") < 0);
                }
                // scope.printMaterialIndex = res.obj.findIndex(item => item.id === "409f87d5-c3a9-11e9-af9b-00163e0e2a52");
                // scope.printMaterialIndex = res.obj.findIndex(item => item.materialName === "光敏树脂-国产9400 (SLA)");
                scope.printMaterialIndex = scope.getDefaultMaterialIndex();
                //console.log("res.obj", res.obj, res.obj[0], scope.printMaterialIndex);
                // 初始化
                scope.printColorIndex = 0;
                scope.count = 1;
                scope.deliveryDays = 7;
                scope.getDelivery(scope.printMaterials[scope.printMaterialIndex].id);

                // 计算浮雕的旧价格
                scope.oldPrice = (scope.weight * 0.8).toFixed(1);

                if (scope.onMaterialLoaded) {
                    scope.onMaterialLoaded();
                }
            });
        },

        calcModelSize() {
            this.toExportModelSize = getExportSize2(this.toExportModel);
            let box = this.toExportModelSize.box3;
            // 四舍五入，且不小于 1
            const EPS = 0.01; // 忽略0.01毫米的误差
            //console.log(Math.abs(box.max.x - box.min.x), Math.abs(box.max.y - box.min.y), Math.abs(box.max.z - box.min.z));
            this.length = Math.max(1, Math.round(Math.abs(box.max.x - box.min.x) - EPS));
            this.width = Math.max(1, Math.round(Math.abs(box.max.y - box.min.y) - EPS));
            this.height = Math.max(1, Math.round(Math.abs(box.max.z - box.min.z) - EPS));
            this.volume = Math.max(1, Math.round(this.toExportModelSize.volume - EPS));
        },

        makeThumbImage(thumbCanvas) {

            thumbCanvas = thumbCanvas || this.$refs.canvas || this.$refs.canvas3d;

            // 缩略图
            let canvas = document.createElement("canvas");
            let s = Math.min(thumbCanvas.width, thumbCanvas.height);
            canvas.width = 200;
            canvas.height = 200;
            let ctx = canvas.getContext("2d");
            ctx.drawImage(thumbCanvas, (thumbCanvas.width - s) / 2, (thumbCanvas.height - s) / 2, s, s,
                0, 0, 200, 200);

            this.image = canvas.toDataURL("image/jpg");
            //console.log("image", this.image);
        },

        makeModelForPrint(thumbCanvas) {
            if (!("getModelToPrint" in this)) {
                console.error("应当实现方法 getModelToPrint");
            }
            this.toExportModel = this.getModelToPrint();

            this.calcModelSize();
            this.makeThumbImage(thumbCanvas);
        },

        updatePriceOnChange() {
            this.toExportModel = this.getModelToPrint();
            if (this.toExportModel) {
                this.calcModelSize();
                if (this.volume > 0 && this.printMaterials.length > 0) {
                    this.getPrice();
                }
            }
        },

        // 本地计算
        updatePriceOnChangeLocal() {
            this.toExportModel = this.getModelToPrint();
            if (this.toExportModel) {
                this.calcModelSize();
                if (this.volume > 0 && this.printMaterials.length > 0) {
                    this.getPriceLocal();
                }
            }
        },

        // getModelToPrint() {
        //     let group = currentMesh;
        //     return group;
        // },
    },
    computed: {
        showMask() {
            return this.textPop || this.showPrint;
        },
        selectedColor() {
            return this.selectedMaterial.listColor[this.printColorIndex];
        },
        selectedMaterial() {
            return this.printMaterials[this.printMaterialIndex];
        },
        weight() {
            return this.volume * this.selectedMaterial.density;
        },
        newlength() {
            return this.boxData.size.w;
        },
        newWidth() {
            return this.boxData.size.h;
        },
        newHeight() {
            return this.boxData.size.d;
        },
        newDept() {
            return this.boxData.size.t;
        },
    },
}


// WEBPACK FOOTER //
// ./src/3dapps/mixins/printModel.js